import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import mediaImage from './../../../assets/images/user.jpg';
import TextField from '../../TextField';
import FpgeeditIcon from '../../../icons/fpgediticon';
import FpgDisableIcon from '../../../icons/fpgdisableicon';
import FpgpublishIcon from '../../../icons/fpgpublishicon';
import FpgDeleteIcon from '../../../icons/fpgdeleteicon';
import AddFileIcon from '../../../icons/plusicon';
import PendingIcon from '../../../icons/pendingicon';
import VerifyIcon from '../../../icons/verifyicon';
import Select from 'react-select';
import DropdownMaster from './../../../component/DropdownMaster';

import FpgMinusIcon from './../../../icons/fpgminusicon';
import FpgPlusIcon from './../../../icons/fpgplusicon';
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import Geocode from "react-geocode";



import UploadForm from './UploadForm';
//moment import
import moment from "moment";

//  Date Picker
import DatePicker from "react-datepicker";

//Loader
import Loader from '../../loader';

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Service import
import service from '../../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';
import DropdownScreening from '../../DropdownScreening';
import ErrorPopUp from '../../errorPopUp';
import PopUpCustomAll from './popUpCustomAll';
import commonImage from '../../../commonImage';
Geocode.setApiKey("AIzaSyBIAQdrAHjH5culyhjVeDRKYQwSxH4OBh8");

let sub;

const mapStateToProps = state => ({
  LiveSceeringEditId: state.LiveSceeringEditId,
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch)
};

class LiveScreeningTab extends Component {
  constructor(props) {
    super(props)

    this.state = {
      discardPopup: false,
      liveDisabled: false,
      errorPopup: false,
      imagePreloader: false,
      liveScreeningId: this.props.LiveSceeringEditId,
      liveScreening: this.props.liveScreening,
      liveScreeningAccessibility: [],
      disabledVerifyfBtn: false,
      selectedOption: null,
      image: '',
      name: "",
      location: {
        street: '',
        city: '',
        state: '',
        zip: '',
        latitude: '',
        longitude: '',
      },
      ticketLink: '',
      accessibilityLink: '',
      liveScreeningFilms: '',
      films: [{
        _id: Math.random(),
        filmsId: { _id: "" },
        accessibility: []
      }]
    }
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        websiteValid: {  // name the rule
          message: 'Please use a valid name of the :attribute',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
          },
          required: false  // optional
        },
        apostrophe: {  // name the rule
          message: 'Please use a valid name of the :attribute',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
          },
          required: false  // optional
        },
        companyName: {  // name the rule
          message: 'Please use a valid name of the :attribute',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
          },
          required: false  // optional
        }
      }
    });
    this.apiserve = new service();
  }
  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  componentWillUnmount = () => {
    // this.props.LiveSceeringEditData('')
    sub.unsubscribe();
  }

  componentDidMount() {

    if (this.state.liveScreeningId) {
      this.apiserve.sendevent("fpg|liveScreening|getDetail", {
        liveScreeningId: this.state.liveScreeningId
      });
    }
    this.apiserve.sendevent("fpg|liveScreening|dropList|film", {});

    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "fpg|liveScreening|add":
          if (!response.error) {
            this.setState({
              loaderFlag: false,
              liveDisabled: true,
            })
            this.apiserve.success('Created successfully.')
            this.props.history.push('/filmlist')
          }
          else {
            this.setState({
              liveDisabled: false,
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }

          break;
        case "fpg|liveScreening|edit":
          if (!response.error) {
            this.setState({
              loaderFlag: false,
              liveDisabled: true
            })
            this.apiserve.success('Updated successfully.')
            this.props.history.push('/filmlist')
          }
          else {
            this.setState({
              errorPopup: true,
              liveDisabled: false,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }

          break;

        case "fpg|liveScreening|getDetail":
          if (!response.error) {
            var screeningLive = response.data && response.data.liveScreeningFilms.map(item => {

              var screening = {
                _id: item._id,
                filmsId: { _id: item && item.film && item.film._id, label: item && item.film && item.film.title },
                accessibility: item.film.accessibility
              }
              return screening
            })
            var screeningLiveNull = [{
              _id: Math.random(),
              filmsId: { _id: "" },
              accessibility: []
            }]
            this.setState({
              name: response.data.name,
              street: response.data.location.street,
              city: response.data.location.city,
              state: response.data.location.state,
              zip: response.data.location.zip,
              latitude: response.data.location.latitude,
              longitude: response.data.location.longitude,
              ticketLink: response.data.ticketLink,
              accessibilityLink: response.data.accessibilityLink,
              image: response.data.image,
              films: screeningLive.length ? screeningLive : screeningLiveNull
            })
          }
          break;
        case "fpg|liveScreening|dropList|film":
          if (!response.error) {
            this.setState({
              screeningAccss: response.data
            })
            var listData = response && response.data.map((item) => {
              var data = {
                _id: item._id, label: item.title
              }
              return data
            })
            this.setState({
              liveScreeningFilms: listData
            })
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        default:
          break;
      }
    });
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  submitLiveScreening = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {

      let filmsData = this.state.films.map((film) => {
        return film.filmsId._id
      })

      filmsData = filmsData.filter(e => e !== '');


      if (this.props.LiveSceeringEditId) {
        this.setState({ loaderFlag: true, liveDisabled: true, })
        let editLiveScreening = {
          liveScreeningId: this.state.liveScreeningId,
          name: this.state.name,
          image: this.state.image,
          location: {
            street: this.state.street,
            state: this.state.state,
            city: this.state.city,
            zip: this.state.zip,
            latitude: this.state.latitude,
            longitude: this.state.longitude
          },
          ticketLink: this.state.ticketLink,
          accessibilityLink: this.state.accessibilityLink,
          films: filmsData
        }
        this.apiserve.sendevent("fpg|liveScreening|edit", editLiveScreening);
      } else {
        this.setState({ loaderFlag: true })
        let addLiveScreening = {
          name: this.state.name,
          image: this.state.image,
          location: {
            street: this.state.street,
            state: this.state.state,
            city: this.state.city,
            zip: this.state.zip,
            latitude: this.state.latitude,
            longitude: this.state.longitude
          },
          ticketLink: this.state.ticketLink,
          accessibilityLink: this.state.accessibilityLink,
          films: filmsData
        }
        this.apiserve.sendevent("fpg|liveScreening|add", addLiveScreening);
      }

    }
    else {
      this.setState({
        messageModal: true,
        liveDisabled: false
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  cancelLiveScreening = () => {
    // this.props.dispatch({type: 'CurrentTab', res: 3})
    this.setState({
      discardPopup: true
    })
  }

  dropChangeLiveScereening = (e, id) => {
    const { name, value } = e.target;
    const { films } = this.state
    var access = this.state.screeningAccss.find(_ => _._id === value)
    const newFilms = films.map(element => {
      if (element._id === id) {
        element[name] = { _id: value, label: name }
        if (access)
          element['accessibility'] = access.accessibility
      }
      return element
    });
    this.setState({ films: newFilms })
  }

  addFilms = (item) => {
    var filmsData = {
      _id: Math.random(),
      filmsId: { _id: '' },
      accessibility: []
    }
    var oldFilms = this.state.films
    oldFilms.push(filmsData)
    this.setState({
      films: oldFilms
    });

  }

  removeFilms = (i) => {
    var filteredscreening = this.state.films.filter(_ => _._id !== i)

    this.setState({
      films: filteredscreening
    });
  }

  handleImage(e) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        this.upload.value = "";

        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
          setTimeout(() => {
            this.imageUpload(file,event.target.result);
          }, 1000)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      })
    }
  }

  imageUpload = (file, img) => {
    this.setState({ imagePreloader: true })

    var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
        this.setState({
          image: value,
          imagePreloader: false
        });
      });
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  closeAdminUser = () => {
    this.setState({
      discardPopup: false
    });
  };

  discardPopupYes = () => {
    this.props.CurrentTab(3)
    this.props.history.push({
      pathname: "/filmlist",
      callFrom: 3
    });
  };

  VerifyAddress = () => {
    let address = this.state.street + ',' + this.state.state + ',' + this.state.city + ',' + this.state.zip
    Geocode.fromAddress(address).then(

      response => {
        const { lat, lng } = response.results[0].geometry.location;
        this.setState({
          latitude: lat,
          longitude: lng,
          disabledVerifyfBtn: true,
          alertDisableBtn: false
        })
      },
      error => {
        if (error) {
          this.setState({
            disabledVerifyfBtn: false,
            alertDisableBtn: true
          })
        }
      }
    );
  }


  render() {
    var settings = {
      customPaging: function (i) {
        return (
          <a>{i + 1}</a>
        );
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };


    return (
      <>
        <div className="fpg_tabcontent fpg_create_film">
          <form>
            <div className="d_flex">
              <div className="screen_poster">
                <div className="media_image relative image_loader">
                  {/* <img src='/images/image-placeholder.png' /> */}
                  {this.state.imagePreloader ?
                    <Loader />
                    :
                    <img src={this.state.image ? this.apiserve.imageUrl + this.state.image : '/images/image-placeholder.png'} alt="image" />
                  }
                  <div className="input_file">
                    <input
                      type="file"
                      name="image" id="image"
                      ref={(ref) => this.upload = ref}
                      style={{ display: 'none' }}
                      onChange={this.handleImage.bind(this)}
                      accept=".png, .jpg, .jpeg"
                    />
                    <span onClick={() => { this.upload.click() }}><AddFileIcon /></span>
                  </div>


                  {/* <div className="input_file">
                                    <input type="file" />
                                    <span><AddFileIcon /></span>
                                </div> */}
                </div>
              </div>
              <div className="screening_formdata">
                <div className="field_row horizontal_field">
                  <TextField
                    type="text"
                    placeholder="The Ray Theater"
                    label="Theater Name"
                    name="name" id="name"
                    value={this.state.name}
                    onChange={this.onInputChange}
                  />
                </div>
                <div className="location_row d_flex d_flex_align_center">
                  <div className="field_row horizontal_field location">
                    <TextField
                      type="text"
                      placeholder="1768 Park Ave"
                      label="Location"
                      name="street" id="street"
                      value={this.state.street}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="field_row horizontal_field city">
                    <TextField
                      type="text"
                      placeholder="City"
                      name="city" id="city"
                      value={this.state.city}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="field_row horizontal_field state">
                    <TextField
                      type="text"
                      placeholder="State"
                      name="state" id="state"
                      value={this.state.state}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="field_row horizontal_field zip">
                    <TextField
                      type="text"
                      placeholder="Zip"
                      name="zip" id="zip"
                      value={this.state.zip}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="field_row horizontal_field zip">
                    <button className="active" type='button' onClick={() => this.VerifyAddress()} disabled={this.state.disabledVerifyfBtn ? true : false}>verify</button>
                  </div>
                  <span>{this.state.disabledVerifyfBtn ? <VerifyIcon /> : this.state.alertDisableBtn ? <PendingIcon /> : ''}  </span>
                </div>
                <div className="field_row horizontal_field">
                  <TextField
                    type="text"
                    placeholder="https://raytheater.com/tickets"
                    label="Buy Ticket Link"
                    name="ticketLink" id="ticketLink"
                    value={this.state.ticketLink}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message('ticket link', this.state.ticketLink, 'websiteValid')}
                  />
                </div>
                <div className="field_row horizontal_field">
                  <TextField
                    type="text"
                    placeholder="https://raytheater.com/access"
                    label="Theater Accessibility Link"
                    name="accessibilityLink" id="accessibilityLink"
                    value={this.state.accessibilityLink}
                    onChange={this.onInputChange}
                    fpgerror={this.validator.message('ticket link', this.state.accessibilityLink, 'websiteValid')}
                  />
                </div>
                {/* <div className="field_row horizontal_field">
                            {this.state.accessibility.map((item,index)=>{
                                return(
                                <>
                                <div className="field_row_inner">
                                {index === 0 && 
                                    <label>Accessibility</label>
                                }
                                    <div className="field_input relative">
                                    <TextField 
                                        type="text" 
                                        placeholder="Accessibility" 
                                        name="accessibility" id="accessibility"
                                        value={item.access}
                                        onChange={(e) => this.onInputChangeAccess(e,item._id)}
                                />
                                    </div>
                                </div>
                                {index === 0 ? 
                                    <span className="pointer" onClick={()=>this.addAccess(item)}>
                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff"/>
                                    </span>
                                    :
                                    <>
                                        <span className="pointer" onClick={()=>this.removeAccess(item._id)}>
                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff"/>
                                        </span>
                                        <span className="pointer" onClick={()=>this.addAccess(item)}>
                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff"/>
                                        </span>
                                    </>
                                }
                                </>
                                    )
                                })}
                                
                            </div> */}
                {this.state.films.map((item, index) => {
                  return (
                    <div className="select_film_box_main mt_15">
                      <div className="select_film_box">
                        <div className="select_film_header">
                          <h3>Select Films</h3>
                        </div>
                        <div className="select_film_content">
                          <div className="field_row horizontal_field">
                            <div className="field_row_inner">
                              <label>Films</label>
                              <div className="field_input relative">
                                <DropdownScreening
                                  name='filmsId'
                                  id="filmsId"
                                  options={this.state.liveScreeningFilms}
                                  value={item && item.filmsId && item.filmsId._id}
                                  onChange={(e) => this.dropChangeLiveScereening(e, item._id)}
                                />
                              </div>
                            </div>
                          </div>
                          {/* <div className="field_row horizontal_field select_film_accessibility">
                            <div className="field_row_inner">
                              <label>Accessibility</label>
                              <div className="field_input relative">
                                {item.accessibility.map((item) => <p>{item.name}</p>)}
                              </div>
                            </div>
                          </div> */}

                        </div>

                      </div>
                      <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                        {index === 0 ?
                          <span className="pointer" onClick={() => this.addFilms(item)}>
                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                          </span>
                          :
                          <>
                            <span className="pointer" onClick={() => this.removeFilms(item._id)}>
                              <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                            </span>
                            <span className="pointer" onClick={() => this.addFilms(item)}>
                              <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                            </span>
                          </>
                        }
                      </p>
                    </div>
                  )
                })}
              </div>
              <div className="text_center field_row w_100 buttons_outer mb_0">
                <button className="uppercase" type='button' onClick={(e) => this.cancelLiveScreening(e)}>CANCEL</button>
                <button className="uppercase active" type='button' onClick={(e) => this.submitLiveScreening(e)} disabled={this.state.liveDisabled ? true : false}>SAVE</button>
              </div>
            </div>
          </form>
          {this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
          }
          {this.state.discardPopup ? (
            <PopUpCustomAll
              HeaderName="Discard Changes?"
              insideDetails="Leaving this page without saving will discard all changes"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.discardPopupYes}
            />
          ) : (
              ""
            )}
        </div>

      </>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LiveScreeningTab);

